// src/utils/coreassure/kpiApi.js
//
// CoreAssure KPI Risk Engine (D-048 §4.3) — Day 5-7 MVP frontend API client.
// Per CR-2026-CA-NAMESPACE §2.1: file lives under src/utils/coreassure/.
// Per CR-2026-CA-NAMESPACE §2.5: audit_log event_type prefix is `CA-KPI-`.

import ApiCall from "../apicall";

// ── KPI dashboard read ──────────────────────────────────────────────────────
export const kpiApi = {
  /**
   * Fetch tenant-wide KPI dashboard. Server-side 5-min in-memory cache.
   * Cache MISS triggers DB aggregation + writes one CA-KPI-VIEW audit_log row.
   * Cache HIT returns instantly + writes nothing.
   *
   * @param {Object} [opts]
   * @param {boolean} [opts.forceRefresh] if true, sends `?force=1` query
   *   param which the server interprets as a cache-bypass.
   */
  fetch: ({ forceRefresh } = {}) =>
    ApiCall.get(`/coreassure/kpi${forceRefresh ? "?force=1" : ""}`),
};

// ── Color thresholds (kept in sync with backend) ────────────────────────────
export const KPI_COLOR = {
  GREEN: "GREEN",
  AMBER: "AMBER",
  RED:   "RED",
  INFO:  "INFO",
  GREY:  "GREY",
};

export const KPI_COLOR_PALETTE = {
  GREEN: { bg: "#e8f5ec", fg: "#127038", border: "#127038" },
  AMBER: { bg: "#fff5e0", fg: "#a06010", border: "#a06010" },
  RED:   { bg: "#fdecea", fg: "#a01a1a", border: "#a01a1a" },
  INFO:  { bg: "#e8f0f7", fg: "#0a3a6a", border: "#0a3a6a" },
  GREY:  { bg: "#f0f0f0", fg: "#6b6b6b", border: "#9b9b9b" },
};

export const CATEGORY_LABEL = {
  quality:     "Quality",
  operational: "Operational",
  financial:   "Financial-proxy",
};

// Format helpers — keep KPI tile rendering consistent
export function formatKpiValue(value, unit) {
  if (value == null) return "—";
  if (unit === "%") return `${value}%`;
  if (unit === "days") return `${value}`;
  if (unit === "count") return `${value}`;
  return String(value);
}
